import { type SearchEntry } from '@ctn/ui/types/ctn-filter-bar';
import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import { PAGE_SIZE } from '@/constants/table.constants';

export const PAYLOAD_PAGINATION = {
	start: 0,
	limit: PAGE_SIZE.OPERACIONES,
};

export const PAYLOAD_DEFAULT = {
	...PAYLOAD_PAGINATION,
};

export type FilterFormData = {
	tipoBusqueda: string;
	busqueda: string;
	listaIdsTipos: string[];
	listaIdsSubtipos: string[];
	listaIdsEstados: string[];
	search?: SearchEntry[];
};
    
export const getSchema = (): Resolver<FilterFormData> => {
	const schema = yup.object().shape({
		tipoBusqueda: yup.string(),
		busqueda: yup.string(),
		listaIdsTipos: yup.array(),
		listaIdsEstados: yup.array(),
		listaIdsSubtipos: yup.array(),
	});
	return yupResolver(schema) as Resolver<FilterFormData>;
};
    
export const defaultValues = (): FilterFormData => ({
	tipoBusqueda: 'numeroTramiteExterno',
	busqueda: '',
	listaIdsTipos: [],
	listaIdsSubtipos: [],
	listaIdsEstados: [],
	search: [],
});